export default __webpack_public_path__ + "e9f4af0a1c5aab0e211ebfb1ad24089d.svg";